export const DEFAULT_CONFIRMATION_TEXT = "yes";
